import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar, { BOTTOM_NAV_HEIGHT } from './Sidebar';

/**
 * Shell with sidebar (desktop) / bottom nav (mobile) and main content area.
 */
function MainLayout(): React.ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: '#F9FAFB',
      }}
    >
      <Sidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          overflow: 'auto',
          p: 4,
          pb: { xs: BOTTOM_NAV_HEIGHT + 24, lg: 4 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainLayout;
